import src from "IMAGE";
export default { src, width: 232, height: 121, blurWidth: 0, blurHeight: 0};
